module.exports = __webpack_public_path__ + "img/chat.e0882d0b.png";